import React from 'react';

import './NavBarButton.css';

function NavBarButton({ value, onClick = () => {} }) {
    return (
      <input type='button' className='App-button-navBar' value={value} onClick={onClick}/>
    );
  }
  
  export default NavBarButton;

